var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockB({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 73.3334C58.4095 73.3334 73.3333 58.4096 73.3333 40.0001C73.3333 21.5906 58.4095 6.66675 40 6.66675C21.5905 6.66675 6.66663 21.5906 6.66663 40.0001C6.66663 58.4096 21.5905 73.3334 40 73.3334Z",
    stroke: "#121216",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20V40L53.3333 46.6667",
    stroke: "#121216",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockB);
export default __webpack_public_path__ + "static/media/clock-b.8c29aaf2033eca560a3f0d84a1ea5cb5.svg";
export { ForwardRef as ReactComponent };